export default "<p>call-queue works!</p>\n";